import React from 'react';
import bill from "../static/img/bill.png";
import { useThemeManager } from "../Hooks/ThemeManager";

const Billimg = ({ theme }) => {
  const { themeColors } = useThemeManager();
  return (
    <div className='text-container' style={{ color: themeColors?.secondary }}>
      <span className="tituloRealizar text-right-block" >¡Mantente al día!</span>
      <span className="text-right-block">Con nuestros múltiples métodos de pagos</span>
      <div className="center-all">
        <img src={bill} alt="Métodos de Pago" className='img-bill' />
      </div>
    </div>
  );
};

export default Billimg;